export default __webpack_public_path__ + "static/media/track-stream.95ee4ae1.svg";